import React, { useState } from 'react';
import Image from 'next/image';

interface JeuBenProps {
	onComplete: (score: number) => void;
}

const questions = [
	{
		question: "Combien de kilomètres ont parcouru les Doudous en voiture lors de leur périple américano-canadien (un seul conducteur) : ?",
		image: "/img/paysage.png",
		options: ["3300Km", "4300Km", "5300Km", "6300Km"],
		answer: 2,
		type: 'choice',
	},
	{
		question: "Quel est ce pays que les doudous ont visité en 2021 ?",
		image: "/img/logo3.png",
		answerText: "Vatican",
		type: 'text',
	},
];

const JeuBen: React.FC<JeuBenProps> = ({ onComplete }) => {
	const [step, setStep] = useState(0);
	const [selected, setSelected] = useState<number | null>(null);
	const [showResult, setShowResult] = useState(false);
	const [score, setScore] = useState(0);
	const [textInput, setTextInput] = useState("");
	const [textAnswered, setTextAnswered] = useState(false);
	const [textCorrect, setTextCorrect] = useState<boolean | null>(null);

	const handleOption = (idx: number) => {
		setSelected(idx);
		setShowResult(true);
		if (idx === questions[step].answer) setScore(s => s + 1);
		setTimeout(() => {
			setShowResult(false);
			setSelected(null);
			if (step < questions.length - 1) {
				setStep(s => s + 1);
			} else {
				onComplete(score);
			}
		}, 1200);
	};

	const handleTextSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		const correct = textInput.trim().toLowerCase() === (questions[step].answerText as string).toLowerCase();
		setTextCorrect(correct);
		setTextAnswered(true);
		if (correct) setScore(s => s + 1);
		setTimeout(() => {
			setTextAnswered(false);
			setTextInput("");
			setTextCorrect(null);
			if (step < questions.length - 1) {
				setStep(s => s + 1);
			} else {
				onComplete(score);
			}
		}, 1200);
	};

	return (
		<div className="card bg-gradient-to-br from-gray-50 to-gray-200 border-gray-300 p-8 rounded-xl shadow-lg text-center">
			<div className="mb-4 flex justify-center">
				<Image src={questions[step].image} alt="illustration" width={120} height={120} className="rounded-lg object-contain" />
			</div>
			<div className="mb-4 text-lg font-semibold text-bordeaux-700">{questions[step].question}</div>
			{/* Affichage selon le type de question */}
			{questions[step].type === 'choice' && Array.isArray(questions[step].options) && (
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
					{questions[step].options.map((opt: string, idx: number) => (
						<button
							key={opt}
							onClick={() => !showResult && handleOption(idx)}
							className={`p-3 rounded-lg border-2 transition-all font-medium ${
								selected === idx
									? idx === questions[step].answer
										? 'bg-green-100 border-green-400 text-green-700'
										: 'bg-red-100 border-red-400 text-red-700'
									: 'bg-white border-blue-200 hover:bg-cyan-50'
							}`}
							disabled={showResult}
						>
							{opt}
						</button>
					))}
				</div>
			)}
			{questions[step].type === 'text' && (
				<form onSubmit={handleTextSubmit} className="mb-4 flex flex-col items-center gap-3">
					<input
						type="text"
						value={textInput}
						onChange={e => setTextInput(e.target.value)}
						className="input-field w-full max-w-xs"
						placeholder="Ta réponse..."
						disabled={textAnswered}
						autoFocus
					/>
					<button
						type="submit"
						className="btn-primary px-6 py-2"
						disabled={textAnswered || textInput.trim() === ""}
					>
						Valider
					</button>
				</form>
			)}
			{/* Feedback pour la question texte */}
			{questions[step].type === 'text' && textAnswered && (
				<div className={`mt-2 font-bold ${textCorrect ? 'text-green-700' : 'text-red-700'}`}>{textCorrect ? 'Bonne réponse !' : `Mauvaise réponse. C'était : ${questions[step].answerText}`}</div>
			)}
			<div className="text-bordeaux-600 text-sm mb-2">Question {step + 1} / {questions.length}</div>
			{/* Score final si dernière question texte */}
			{step === questions.length - 1 && ((questions[step].type === 'choice' && showResult) || (questions[step].type === 'text' && textAnswered)) && (
				<div className="mt-2 text-bordeaux-700 font-bold">Score : {score} / {questions.length}</div>
			)}
		</div>
	);
};

export default JeuBen;
